import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
    selector: 'app-section-input-modal',
    templateUrl: './venue-section-input.component.html',
    styleUrls: ['./venue-section-input.component.css']
})

export class VenueSectionInputModalComponent implements OnInit {

    public hasValidationErrors = false;

    public csvSectionFile: File = null;
    public showAdvancedRangeOptions: boolean = false;

    public form: FormGroup;

    @Output() 
    public submitSections = new EventEmitter()

    constructor(
        private bsModalRef: BsModalRef,
        private fb: FormBuilder,
        private spinner: NgxSpinnerService
    ){}

    ngOnInit (): void {
        
        this.initForm();
    }

    initForm () {

        this.form = this.fb.group({
            csvSectionFile: [null],
            startRange: [null],
            endRange: [null],
            rangePrefix: ["", [Validators.maxLength(10)]],
            rangeSuffix: ["", [Validators.maxLength(10)]]
        }, {validators: this.validateForm});
    }

    validateForm (form: FormGroup) : { [key: string]: any } | null {

        if (form.controls.csvSectionFile.value && form.controls.startRange.value && form.controls.endRange.value) {

            return {invalidSections : true}
        }

        if (!form.controls.csvSectionFile.value && !form.controls.startRange.value && !form.controls.endRange.value) {

            return {required : true}
        }

        if (form.controls.startRange.value > form.controls.endRange.value) {
        
            return {invalidRange: true};
        }

        return null;
    }

    submit () {

        this.hasValidationErrors = !this.form.valid;

        if (this.hasValidationErrors) {

            this.form.markAllAsTouched();
            this.form.markAsDirty();
            return;
        }

        if (this.csvSectionFile) {

            this.spinner.show();

            let sections: string[] = [];
            const reader = new FileReader();
            reader.onload = (event) => {

                this.spinner.hide();
                const data = event.target.result as string;
                sections = data.split(/[,\n\t\r]+/);

                for (let i = 0; i < sections.length; i++) {

                    sections[i] = sections[i].trim();

                    if (sections[i].length === 0) {

                        sections.splice(i, 1);
                    }
                }

                this.submitSections.emit(sections);
                this.close();
            }

            reader.readAsText(this.csvSectionFile);
        }

        if (this.form.controls.startRange.value && this.form.controls.endRange.value) {

            this.submitSections.emit({
                startRange: this.form.controls.startRange.value, 
                endRange: this.form.controls.endRange.value,
                rangePrefix: this.form.controls.rangePrefix.value,
                rangeSuffix: this.form.controls.rangeSuffix.value
            });

            this.close();
        }
    }

    addSectionFile (file: File) {

        this.csvSectionFile = file;
    }

    deleteSectionFile () {

        this.csvSectionFile = null;
        this.form.controls.csvSectionFile.setValue(null);
        this.form.setErrors({
            invalidSections: false,
            invalidRange: this.form.errors?.invalidRange,
            required: this.form.errors?.required
        });
        this.form.updateValueAndValidity();
    }

    close () {
      
        this.bsModalRef.hide();
    }
}